import { BehaviorSubject } from 'rxjs';
import { NavbarItem } from './navbar-item.model';

interface ModuleData {
  module: string;
  navbar: NavbarItem[];
}

const initialState: ModuleData = { module: '', navbar: [] };

export default class NavbarService {
  private _current: BehaviorSubject<ModuleData> = new BehaviorSubject(initialState);
  get current$() {
    return this._current.asObservable();
  }
  get current() {
    return this._current.value;
  }
  set(value: ModuleData) {
    if (!value) {
      this._current.next(initialState);
      return;
    }
    this._current.next(value);
  }
  get module(): string {
    return this._current.value.module ? this._current.value.module : initialState.module;
  }
  get navbar(): NavbarItem[] {
    return this._current.value.navbar ? this._current.value.navbar : initialState.navbar;
  }
}
